import React from "react";

import "./styles.css";

import StateProvider from "./components/StateProvider/StateProvider";

const App = () => {
  return <StateProvider />;
};

export default App;
